import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/img/logo-black.png'


const _hoisted_1 = {
  class: "tab-pane fade in active show",
  id: "members",
  style: {"overflow-x":"auto"}
}
const _hoisted_2 = {
  ref: "refLogo",
  src: _imports_0,
  alt: "store",
  style: {"display":"none"}
}
const _hoisted_3 = {
  key: 1,
  class: "datatables table table-striped table-bordered"
}
const _hoisted_4 = { class: "thead-dark" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", null, " Commercial ", -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_gif = _resolveComponent("loader-gif")!
  const _component_element_per_page = _resolveComponent("element-per-page")!
  const _component_member_route = _resolveComponent("member-route")!
  const _component_element_status_payment = _resolveComponent("element-status-payment")!
  const _component_btn_default = _resolveComponent("btn-default")!
  const _component_btn_delete = _resolveComponent("btn-delete")!
  const _component_not_found = _resolveComponent("not-found")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isRequestPayment)
      ? (_openBlock(), _createBlock(_component_loader_gif, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_element_per_page),
    _createElementVNode("img", _hoisted_2, null, 512),
    (_ctx.transactions && _ctx.transactions?.length > 0)
      ? (_openBlock(), _createElementBlock("table", _hoisted_3, [
          _createElementVNode("thead", _hoisted_4, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, [
                (_ctx.reference == 'encaissement')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.i18n.t('tables.payment.reference_type_encaissement')), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.i18n.t('tables.payment.reference_type_decaissement')), 1))
              ]),
              (!_ctx.isMember)
                ? (_openBlock(), _createElementBlock("th", _hoisted_7, " Détails de l'opération "))
                : _createCommentVNode("", true),
              _hoisted_8,
              _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.payment.paymentDate')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.payment.paymentMethod')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.payment.chequeName')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.payment.bankName')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.payment.chequeNum')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.payment.dueDate')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.payment.amount_paid')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.payment.status')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.action')), 1)
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transactions, (transaction, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                value: "member.id",
                key: `transaction-${transaction?.id}-${index}`
              }, [
                _createElementVNode("td", null, _toDisplayString(_ctx.paymentTypePathLabels[transaction?.reference_type] ?? 'Inconnu'), 1),
                (!_ctx.isMember)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_9, [
                      (transaction?.member)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                            (_ctx.hasPermission('fiche_member'))
                              ? (_openBlock(), _createBlock(_component_member_route, {
                                  key: 0,
                                  memberUUID: transaction?.member?.uuid,
                                  matricule: transaction?.member?.name
                                }, null, 8, ["memberUUID", "matricule"]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.isMember ? _ctx.member?.matricule : transaction?.member?.matricule), 1))
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", {
                        innerHTML: transaction?.reference_detail?.name
                      }, null, 8, _hoisted_12)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("td", null, _toDisplayString(transaction?.reference_detail?.sellerName ?? ''), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(transaction?.paymentDate)), 1),
                _createElementVNode("td", null, _toDisplayString(transaction.paymentMethod ?? '-'), 1),
                _createElementVNode("td", null, _toDisplayString(transaction.chequeName ?? '-'), 1),
                _createElementVNode("td", null, _toDisplayString(transaction?.bankName ?? '-'), 1),
                _createElementVNode("td", null, _toDisplayString(transaction?.chequeNum ?? '-'), 1),
                _createElementVNode("td", null, [
                  (transaction?.status == 'scheduled')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                        _createElementVNode("small", null, [
                          _createElementVNode("b", null, _toDisplayString(_ctx.i18n.t('tables.payment.accessBlockDate')), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.formatDate(transaction?.dueDate) ?? '-'), 1)
                ]),
                _createElementVNode("td", null, _toDisplayString(transaction?.amount_paid ?? 0.00) + " " + _toDisplayString(_ctx.i18n.t('symbole.currency.mad')), 1),
                _createElementVNode("td", null, [
                  _createVNode(_component_element_status_payment, {
                    status: transaction?.status
                  }, null, 8, ["status"])
                ]),
                _createElementVNode("td", null, [
                  (transaction.reference_detail?.memberUUID && _ctx.hasPermission('impayes') && transaction?.reference_type === _ctx.PAYMENT_TYPE_PATH.SUBSCRIPTION)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                        (_ctx.hasPermission('impayes'))
                          ? (_openBlock(), _createBlock(_component_btn_default, {
                              key: 0,
                              btnClass: `btn btn-show m-1`,
                              onDefault: ($event: any) => (_ctx.redirectTo({ name: 'impayes', params: { subscriptionID: transaction.reference_detail?.id, clubUUID: _ctx.clubUUID, memberUUID: transaction.reference_detail?.memberUUID } })),
                              icon: "eye",
                              tooltip: _ctx.i18n.t('button.details')
                            }, null, 8, ["onDefault", "tooltip"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.hasPermission('delete_transaction'))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                        (transaction?.reference_type !== _ctx.PAYMENT_TYPE_PATH.PRODUCT_SALE)
                          ? (_openBlock(), _createBlock(_component_btn_delete, {
                              key: 0,
                              onDelete: ($event: any) => (_ctx.Delete(transaction?.id))
                            }, null, 8, ["onDelete"]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_16, [
                              _createTextVNode(" Vous ne pouvez"),
                              _hoisted_17,
                              _createTextVNode("pas le supprimer. ")
                            ]))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createVNode(_component_not_found, {
            text: _ctx.i18n.t('message.data_not_found.title'),
            icon: "warning"
          }, null, 8, ["text"])
        ]))
  ]))
}